// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const WarningOutline = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 16}
    height={size ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.9 2.764 5.467 9.492c.383.668-.112 1.494-.9 1.494H2.533c-.789 0-1.284-.826-.9-1.494l5.465-9.492c.394-.685 1.408-.685 1.802 0"
    />
    <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" d="M8 9.25v-2.5" />
    <path fill="currentColor" d="M8 12.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" />
  </svg>
);
const ForwardRef = forwardRef(WarningOutline);
export default ForwardRef;
